import WinPublicSummary from '../Summaries/summaryObjects/Implementation/WinPublicSummary.js';
import { tShipLinks } from '../util/townshipLinks.js'
import winTable from './tables/winTable.js';

export default {

    url: PublicPropertySearchService + "/1", 

    where: ((add) => {
        add = add.trim().replace(/-/g, "");
        return "PIN LIKE '%" + add + "%' OR (LOPHouseNumber || ' ' || LOPStreetName || ' ' || LOPStreetSuffix) LIKE '%" + add + "%' OR (LOPHouseNumber || ' ' || LOPPrefixDirectional || ' ' || LOPStreetName || ' ' || LOPStreetSuffix) LIKE '%" + add + "%'";
        }), 

    output: ( (featureAttributes) => {
        const fragment = document.createDocumentFragment();
    
        // Address with bold formatting
        const addressElement = document.createElement('b');
        addressElement.textContent = `${featureAttributes.LOPHouseNumber} ${featureAttributes.LOPPrefixDirectional} ${featureAttributes.LOPStreetName} ${featureAttributes.LOPStreetSuffix}`;
        fragment.appendChild(addressElement);
        fragment.appendChild(document.createElement('br'));
        
        if (featureAttributes.OptOut != "Y")
        {
            // Pin information
            const pinText = document.createTextNode("Pin: " + featureAttributes.PIN);
            fragment.appendChild(pinText);
            fragment.appendChild(document.createElement('br'));

            // Township link handling
            let tshipLink = featureAttributes.TownshipName;
            let pins = { PIN: featureAttributes.PIN, DashPIN: featureAttributes.DashPIN };
            if (tShipLinks[featureAttributes.TownshipName]) {
                tshipLink = tShipLinks[featureAttributes.TownshipName](pins);
            }
            const townshipText = document.createElement("span");
            townshipText.innerHTML = "Township: " + tshipLink;
            fragment.appendChild(townshipText);
            fragment.appendChild(document.createElement('br'));

            // Assessment information link
            const assessmentLink = document.createElement('a');
            assessmentLink.href = `http://assessor.wincoil.gov/search/AssessmentRecord.aspx?PIN=${featureAttributes.DashPIN}`;
            assessmentLink.target = '_blank';
            assessmentLink.textContent = 'Assessment Info';
            fragment.appendChild(assessmentLink);
            fragment.appendChild(document.createTextNode(' | '));

            // Tax information link
            const taxLink = document.createElement('a');
            taxLink.href = `http://taxes.wincoil.gov/TaxRecord.aspx?PIN=${featureAttributes.DashPIN}`;
            taxLink.target = '_blank';
            taxLink.textContent = 'Tax Info';
            fragment.appendChild(taxLink);
            fragment.appendChild(document.createElement('br'));

        }

       
    


    
        return fragment;
    }), 

    table: winTable,
    summary: WinPublicSummary
}